<template>
  <div
    class="ma-0 pa-0"
    style="display: inline-block; position: relative"
    :aria-label="stack"
  >
    <vue-flip
      v-model="flipped"
      @mouseover="flipped = true"
      @mouseleave="flipped = false"
      :width="stack == 'latex' ? '2em' : '1.2em'"
      height="1.6em"
    >
      <template v-slot:front>
        <span :class="stackIconClassName">
          <span v-if="stack == 'latex'">
            <tex-icon />
          </span>
          <span v-else-if="stack == 'regex'">(.*)</span>
          <span v-else>
            <i :class="stackIconName(stack)"></i>
          </span>
        </span>
      </template>
      <template v-slot:back>
        <span :class="stackIconClassName" style="right: 0 !important">
          <span v-if="stack == 'latex'">
            <tex-icon />
          </span>
          <span v-else-if="stack == 'regex'">(.*)</span>
          <span v-else>
            <i
              :class="[`devicon-${stacks[stack]?.icon}`, 'stack-icon-back']"
            ></i>
          </span>
        </span>
        <v-fade-transition>
          <span v-show="flipped" class="stack-label px-2">{{
            stacks[stack]?.name
          }}</span>
        </v-fade-transition>
      </template>
    </vue-flip>
  </div>
</template>

<script>
import TexIcon from './TexIcon.vue';
import VueFlip from 'vue-flip';

export default {
  name: 'TechStackIcon',

  components: {
    TexIcon,
    VueFlip,
  },

  props: {
    stack: String,
  },

  computed: {
    stackIconClassName() {
      if (this.stack == 'regex') {
        return 'stack-icon__regex';
      } else if (this.stack == 'latex') {
        return 'stack-icon__latex';
      } else {
        return 'stack-icon';
      }
    },
  },

  methods: {
    stackIconName(stackName) {
      const stack = this.stacks[stackName];
      let iconName = `devicon-${stack?.icon}`;
      if (stack?.suffix) {
        iconName += ' ' + stack.suffix;
      }
      return iconName;
    },
  },

  data: () => ({
    flipped: false,
    stacks: {
      javascript: {
        name: 'JavaScript',
        icon: 'javascript-plain',
        suffix: 'colored',
      },
      typescript: {
        name: 'TypeScript',
        icon: 'typescript-plain',
        suffix: 'colored',
      },
      python: {
        name: 'Python',
        icon: 'python-plain',
        suffix: 'colored',
      },
      java: {
        name: 'Java',
        icon: 'java-plain',
        suffix: 'colored',
      },
      ruby: {
        name: 'Ruby',
        icon: 'ruby-plain',
        suffix: 'colored',
      },
      rails: {
        name: 'Ruby on Rails',
        icon: 'rails-plain',
        suffix: 'colored',
      },
      go: {
        name: 'Go',
        icon: 'go-plain',
        suffix: 'colored',
      },
      html: {
        name: 'HTML',
        icon: 'html5-plain',
        suffix: 'colored',
      },
      css: {
        name: 'CSS',
        icon: 'css3-plain',
        suffix: 'colored',
      },
      sass: {
        name: 'Sass',
        icon: 'sass-plain',
        suffix: 'colored',
      },
      react: {
        name: 'React',
        icon: 'react-plain',
        suffix: 'colored',
      },
      redux: {
        name: 'Redux',
        icon: 'redux-plain',
        suffix: 'colored',
      },
      vue: {
        name: 'Vue',
        icon: 'vuejs-plain',
        suffix: 'colored',
      },
      nextjs: {
        name: 'Next.js',
        icon: 'nextjs-line',
      },
      materialui: {
        name: 'Material UI',
        icon: 'materialui-plain',
        suffix: 'colored',
      },
      nodejs: {
        name: 'Node.js',
        icon: 'nodejs-plain',
        suffix: 'colored',
      },
      expressjs: {
        name: 'Express.js',
        icon: 'express-original',
      },
      flask: {
        name: 'Flask',
        icon: 'flask-original',
      },
      postgresql: {
        name: 'PostgreSQL',
        icon: 'postgresql-plain',
        suffix: 'colored',
      },
      mongodb: {
        name: 'MongoDB',
        icon: 'mongodb-plain',
        suffix: 'colored',
      },
      git: {
        name: 'Git',
        icon: 'git-plain',
        suffix: 'colored',
      },
      latex: {
        name: 'Latex',
        icon: 'latex-plain',
        suffix: 'colored',
      },
      regex: {
        name: 'Regex',
        icon: 'regex-plain',
        suffix: 'colored',
      },
      docker: {
        name: 'Docker',
        icon: 'docker-plain',
        suffix: 'colored',
      },
      aws: {
        name: 'AWS',
        icon: 'amazonwebservices-plain',
        suffix: 'colored',
      },
      shell: {
        name: 'Shell scripting',
        icon: 'bash-plain',
      },
    },
  }),
};
</script>

<style lang="scss" scoped>
.stack-icon {
  padding: 2px 4px;
  display: inline-block;
}

.stack-icon-back {
  @extend .stack-icon;
  // for future night mode colour toggle, if needed;
}

.stack-icon__latex {
  @extend .stack-icon;
  font-size: 0.8em;
  vertical-align: 0.25em;
}

.stack-icon__regex {
  @extend .stack-icon;
  font-size: 0.8em;
  vertical-align: 0.25em;
  color: #122c49;
}

.stack-label {
  font-size: 10pt;
  background-color: dimgray;
  color: white;
  border-radius: 0.7em;
  position: absolute;
  bottom: -0.3em;
  white-space: nowrap;
  left: 50%;
  transform: translateX(-50%);
}
</style>
